import Modal from "../../../Framework/Components/Modals/Modal";
import {ModalType} from "../../../Framework/Components/Modals/ModalTypes";
import {
    deleteSendsPage,
    SendsPageDataType,
    SendsPagesUpdateType,
    useUpdateSendsData
} from "../../../Api/StandaloneSendsEndpoints";
import Button from "../../../Framework/Components/Buttons/Button";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";
import {useState} from "react";

interface ConfirmDeletePageType extends ModalType {
    pageData: SendsPageDataType
}

const ConfirmDeleteSendsPageModal = (props: ConfirmDeletePageType) => {
    const updateSendsData = useUpdateSendsData();
    const [deletingPage, setDeletingPage] = useState<boolean>(false);

    const HandleDelete = async (pageId: number) => {
        if(pageId === -1) return;

        setDeletingPage(true);

        await deleteSendsPage(pageId).then(() => {
            updateSendsData.mutate({
                updateType: SendsPagesUpdateType.DELETE,
                newData: {id: pageId},
            });

            if(props.actionedCallback) {
                props.actionedCallback();
            } else {
                props.closeCallback();
            }
        }).catch((e) => {
            console.error(e.response.data);
        }).finally(() => setDeletingPage(false))
    }

    return (
        <Modal title={`Delete "${props.pageData?.title}"`} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
            <p>This can not be undone, are you sure? </p>
            <Button
                loading={deletingPage}
                title={'Delete'}
                colour={ColourMod.Alert}
                fullWidth={true}
                onClick={() => HandleDelete(props.pageData?.id ?? -1)}
            />
        </Modal>
    )
}

export default ConfirmDeleteSendsPageModal